import { Navigate } from 'react-router-dom';
const ProtectedAdminRoutes = ({
  children,
  allowed,
}: {
  children: React.ReactNode;
  allowed: boolean;
}) => {
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedAdminRoutes;
